// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nb-recent-colors_recent-colors-panel_1uFaJ {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 4px;\n    margin-top: 6px;\n}", ""]);
// Exports
exports.locals = {
	"recent-colors-panel": "nb-recent-colors_recent-colors-panel_1uFaJ",
	"recentColorsPanel": "nb-recent-colors_recent-colors-panel_1uFaJ"
};
module.exports = exports;
